
import { useRouter } from 'next/router'
import { useQuery, useQueryClient } from 'react-query'
import { getPortfolioService, getPersonalProjectsService } from 'services/profile'
import { getTestimoniesService } from 'services/portfolio'
import useSession from './session'

export function usePortfolio(username) {
  const queryClient = useQueryClient()
  const { query: { username: query_username } } = useRouter()
  const { token } = useSession()
  const user = username || query_username
  return useQuery(
    ['GET_PORTFOLIO', user, token],
    () => getPortfolioService({ username: user, token }),
    {
      staleTime: Infinity,
      placeholderData: () => queryClient.getQueryData(['GET_PORTFOLIO', username, '']),
    },
  )
}

export function usePortfolioProjects() {
  const { token } = useSession()
  return useQuery(
    ['GET_PERSONAL_PROJECTS', token],
    () => getPersonalProjectsService({ token }),
    {
      staleTime: Infinity,
    },
  )
}

export function useTestimonies() {
  const { token } = useSession()
  return useQuery(
    'GET_TESTIMONIES',
    () => getTestimoniesService({ token }),
    { enabled: !!token, staleTime: Infinity },
  )
}

export async function prefetchPortfolio({ queryClient, username }) {
  await queryClient.prefetchQuery(
    ['GET_PORTFOLIO', username, ''],
    () => getPortfolioService({ username, token: null, is_ssg: true }),
  )
}
